// Importing necessary libraries
var R = require('ramda');

var getRandomValues = require('get-random-values'); // Exporting utility functions related to weather data processing


var weatherUtils = {
  // Function to extract keys from an object where the values are truthy
  extractTruthyKeys: R.compose(R.keys, R.pickBy(function (value, key) {
    return value;
  })),
  // Function to check if two arrays have any common elements
  doArraysIntersect: R.curry(function (firstArray, secondArray) {
    return R.reduce(function (previous, current) {
      return previous || firstArray.indexOf(current) > -1;
    }, false, secondArray);
  }),
  // Function to group an array of objects by a given path
  groupByPath: R.curry(function (path, array) {
    if (typeof path === 'string') path = path.split('.');
    return array.reduce(function (previous, current) {
      var value = R.path(path, current);
      previous[value] = previous[value] || [];
      previous[value].push(current);
      return previous;
    }, {});
  }),
  // Function to strip HTML tags from a string
  stripHtmlTags: function stripHtmlTags(str) {
    return str.replace(/(<([^>]+)>)/ig, "");
  },
  // Function to add a property to an object using a provided function
  addPropToObj: R.curry(function (property, func) {
    return function (obj) {
      return R.set(R.lensProp(property), typeof func === 'function' ? func(obj) : func, R.clone(obj));
    };
  }),
  // Function to generate a GUID
  generateGUID: function generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      var randomValue = getRandomValues(new Uint8Array(1))[0] % 16 | 0;
      var value = character == 'x' ? randomValue : randomValue & 0x3 | 0x8;
      return value.toString(16);
    });
  },
  // Function to extract keys from an object based on a predicate function
  keysWithPredicate: R.curry(function (predicate, obj) {
    return R.pipe(R.toPairs, R.filter(R.pipe(R.nth(1), predicate)), R.map(R.nth(0)))(obj);
  })
};
module.exports = {
  weatherUtils: weatherUtils
};